<template>

    <div class="container card p-5 shadow m-auto">
        
        <h1>Edit Category </h1>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">{{$t("TITLE")}}</span>
                </div>
                <input v-model="category.title" type="text" class="form-control" :placeholder="$t('TITLE')">
            </div>
            <div class="form-group">
                <div class="input-group-prepend w-100">
                    <span class="input-group-text w-100">{{$t("DESCRIPTION")}}</span>
                </div>
                <html-editor v-model="category.description"></html-editor>
            </div>
        </div>
        <button type="button" @click="editCategory" class="btn btn-primary mb-3">Edit Category</button>
        
    </div>

</template>

<script>
import HtmlEditor from "../../misc/HtmlEditor";

export default {
    data() {
        return {
            category: {
                title: null,
                description: null,
                id: null,
                languageId: ""
            },
            response: {}
        }
    },
    components: {
        HtmlEditor
    },
    computed: {
        languages() {
            return this.$store.getters.systemLanguages;
        }
    },
    methods: {
        editCategory: function() {
            let self = this;
                this.$http.put('/api/categories/edit/', this.category)
                .then(response => {
                    self.response = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
        },
        loadCurrentCategory: function() {
            let self = this;
            this.$http.get('/api/categories/get/' + this.$route.params.categoryId)
            .then(response => {
                self.category = response.data;
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        },
    },
    mounted: function() {
        this.category.id = this.$route.params.categoryId;
        this.loadCurrentCategory();
    },
    watch: {
        response: function(val){
            if(val.success === true){
                setTimeout(() => {
                    this.$router.push(`/admin/categories`);
                }, 1000)
            }
            setTimeout(() => {
                this.response.success = null;
            }, 3000) 
        },       
    }
    
}
</script>

<style scoped lang="scss">
</style>
